import { createStore, sample } from 'effector';

import { object, string } from 'yup';

import { $$deletedAccount } from '@entities/deleted-account';

import { createForm } from '@shared/lib/form';

const $error = createStore(false);

const $errors = createStore({});

const form = createForm({
  initialValues: {
    email: '',

    password: ''
  },

  $errors,

  $schema: createStore(
    object({
      email: string()
        .required('required')

        .trim()

        .nullable()

        .email('is invalid')

        .label('Email'),

      password: string()
        .required('required')

        .trim()

        .nullable()

        .label('Password')
    })
  )
});

const $$restore = {
  form,

  $error
};

sample({
  source: $error,

  fn: error =>
    error
      ? {
          email: 'is incorrect',
          password: 'is incorrect'
        }
      : {},

  target: $errors
});

sample({
  clock: form.submitted,

  target: $$deletedAccount.restoreAccountFx
});

export { $$restore, form };
